import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { GrnService } from "../../../services/grn.service";
import { Combo2Service } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";

@Component({
  selector: "addEditSampleSwatchGrn",
  templateUrl: "./addEditSampleSwatchGrn.html",
  //    changeDetection:ChangeDetectionStrategy.OnPush
})
export class addEditSampleSwatchGrn {
  headerShow: boolean = true;
  bodyShow: boolean = false;
  footerShow: boolean = false;
  type: any;
  row: any;
  data: any;
  filterExpand = false;
  auto_number: number;
  designdata: any = { indent_no: 0, rcvd_type_name: "" };
  designFromList = ["ORDERED", "NON-ORDERED"];
  grnData: any = {
    inv_ref_no: "",
    order_no: 0,
    totalqty: 0,
    grn_date: "",
    grn_no: "",
    po_no: "",
    samp_po_no: "",
    lr_y_date: "",
    inv_y_date: "",
    party_code: "",
    party_name: "",
    rcvd_type: "",
    rcvd_type_name: "",
    lr_no: "",
    lr_date: "",
    lr_amnt: "",
    inv_no: "",
    grn_type: "",
    inv_date: "",
    inv_amnt: "",
    no_of_bales: 0,
    grn_id: "",
    lr_date_formatted: "",
    inv_id: "",
    party_id: "",
    totalamt: 0,
    grand_total: 0,
    round_off: 0,
    discount: 0,
    extras: 0,
    others: 0,
    tax_amount: 0,
    tax_per: 0,
    inv_date_formatted: "",
    pvt_mark: 0,
    indent_no: 0,
    invoice_type: "",
    narration: "",
  };
  qualityList: any;
  grnCompareList = [];
  invoiceCompareList = [];
  mismatchList = [];
  colorList: any;
  colorListback: any;
  styleList1: any;
  codeList: any;
  poList: any;
  invList: any;
  widthList: any[];
  grndata: any = {};
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  partyList: any;
  OdList: any;
  poNoList: any;
  design_no: any;
  lrList: any;
  LRList: any;
  design_auto_no: any;
  designList = [];
  isLoading: boolean = false;
  sample_check: boolean = false;
  tempcolorList : any;
  finyearList = [];
  designnoList = [];
  varietyList = [];
  varietyList1 = [];
  typeList: any;
  tempData = [];
  invoiceList = [];
  redirect_to_invoice: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  designType = [{ name: "CORE" }, { name: "NEW" }];
  invoicetypelist = ["COURIER", "TRANSPORT", "HAND DELIVERY"];
  typeList1 = [
    // { name: "OPENING" },
    // { name: "BULK" },
    // { name: "MATCHING" },
    { name: "SAMPLE" },
    { name: "SWATCH" },
    // { name: "WO RETURN" },
    { name: "SAMPLE & SWATCH" },
    // { name: "BULK & SAMPLE" },
  ];
  shipList = [{ name: "LR" }, { name: "COU" }, { name: "HD" }];

  @Input() _params: any;
  designColorList: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    
    let grnData = Object.assign({}, val["data"]);
    this.saveEvent = val["data"].tabevent;
    this.grnData = grnData;
    if (this.mode == "Edit" || this.mode == "View") {
      this.loadeditgrnlist();
      this.polist();
      this.getDesign(this.grnData.po_no);
      //    this.generateOdNo();
      this.grnData.inv_y_date = this.grnData.inv_date;
      // this.grnData.grn_date = this.formatDate(this.grnData.grn_date);
      this.grnData.lr_y_date = this.grnData.lr_date;
      this.grnData.gr_type = this.grnData.gr_type;
      if (this.grnData.lr_no != 0) {
        this.grnData.gr_type = "TRANSPORT";
      }
      this.grnData.samp_po_no = this.grnData.po_no;
      // this.generateOdNo();
      this.onEnterpono(this.grnData.po_no);
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("lrAuto") lrAuto;
  @ViewChild("finAuto") finAuto;
  @ViewChild("poAuto") poAuto;
  @ViewChild("invAuto") invAuto;
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("type1Auto") type1Auto;
  @ViewChild("shipAuto") shipAuto;
  @ViewChild("designAuto") designAuto;
  @ViewChild("colorAuto") colorAuto;
  @ViewChild("grntypeAuto") grntypeAuto;

  widthCtrl: FormControl = new FormControl();
  designCtrl: FormControl = new FormControl();
  pdesignCtrl: FormControl = new FormControl();
  samTypeCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  grnControl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  poCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  lrCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  shipCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private combo: Combo2Service,
    private grn: GrnService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) {
    this.row = {
      design_no: "",
      type1: "",
      type: "",
      quality: "",
      recvd_width: "",
      qty: 0,
      rate: 0,
      amount: 0,
      pd_code: "",
      p_shade: "",
      design_type: "",
      design_from: "ORDERED",
      shade: "",
      color: "",
      style: "",
      lc_rate: 0,
    };
    this.data = {
      grnList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.grnList.push(row);

    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
  }
  ngOnInit() {
    console.log(this.grnData.inv_ref_no);
    this.finyearCombo();
    this.qualitylist();
    this.colorlist();
    // this.styleList();
    this.widthlist();
    this.getVarietyList();
    this.codelist();
    this.agentlist();
    this.typelist();
    this.lrlist();
    this.polist();
    this.tableScroll();

    if (this.mode == "Add") {
      this.grnData.grn_type = "SAMPLE";
      this.grnData.grn_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.grnData.discount = 0;
      this.grnData.tax_amount = 0;
      this.grnData.tax_per = 0;
      this.grnData.others = 0;
      this.grnData.extras = 0;
      this.grnData.grand_total = 0;
      this.grnData.round_off = 0;
      this.grnData.invoice_type = "";
      this.grnData.gr_type = "COURIER";

      //     this.generateOdNo();
      //     this.getAuto();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#samp_po_no").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");

      $("#" + nextEl).focus();
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design_no = this.data.grnList[ind]["design_no"],
      quality = this.data.grnList[ind]["quality"],
      type = this.data.grnList[ind]["type"],
      type1 = this.data.grnList[ind]["type1"],
      design_type = this.data.grnList[ind]["design_type"],
      design_from = this.data.grnList[ind]["design_from"],
      pd_code = this.data.grnList[ind]["pd_code"],
      //  width = this.data.designList[ind]['width'],
      mtrs = this.data.grnList[ind]["mtrs"],
      recvd_width = this.data.grnList[ind]["recvd_width"],
      rate = this.data.grnList[ind]["rate"],
      amt = this.data.grnList[ind]["amt"];

    let nxtRow = $("#row-" + ind).next("tr");

    if (
      (design_no != "" && pd_code != "") ||
      design_type != "" ||
      design_from != ""
    ) {
      if (
        ((fld == "pdcode" && this.grnData.gr_type != "COURIER") ||
          fld == "design_from") &&
        nxtRow.length == 0
      ) {
        for (let i = 0; i < this.data.grnList.length; i++) {
          if (ind + 1 == this.data.grnList.length) {
            this.row.lc_per = this.grnData["lc_per"];

            let rowdetail = Object.assign({}, this.row);

            this.data.grnList.push(rowdetail);

            nxtInd = this.data.grnList.length - 1;
            setTimeout(() => {
              $("#" + fld + "-" + nxtInd).focus();
            }, 500);
          }
        }
      }
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  tableScroll() {
    $(".invscreen").height(window.innerHeight - 495);
    $(".grnbody").width(window.innerWidth - 30);
  }
  onDeleteRow($event, fld, ind) {
    if (this.data.grnList.length > 1) {
      this.data.grnList.splice(ind, 1);

      if ($("#" + fld + "-" + (ind - 1)).length > 0) {
        $("#" + fld + "-" + (ind - 1)).focus();
      } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
        $("#" + fld + "-" + (ind + 1)).focus();
      }
    }
    this.calcTotal();
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    this.grn.getAuto({}).then((res: any) => {
      this.grnData.grn_no = res;
      this.onSaveGrn();
    });
  }

  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }
  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }
  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
      this.colorListback = [...this.colorList];
    });
  }
  getVarietyList() {
    this.combo.varietyStyleCombo().then((res: any) => {

    let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
            if(!unique.some(obj => obj.variety === o.variety)) {
              unique.push(o);
            }
            return unique;
        },[]);
    
      this.varietyList1 =  this.varietyList;

      this.styleList1 = list.reduce((unique, o) => {
        if(!unique.some(obj => obj.style === o.style)) {
          unique.push(o);
        }
        return unique;
    },[]);
   
    });
    
  }
  styleList() {
    this.poservice.styleList({}).then((res: any) => {
      // this.styleList1 = res.data;
    });
  }
  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.codeList = res.data;
      /*  if (this.mode == "Edit") {
                      this.partyCtrl.setValue(this.designdata['party_name']);
                  }*/
    });
  }
  polist() {
    this.grn.getPoList({}).then((res: any) => {
      this.poList = res.data;
    });
  }
  lrlist() {
    this.grn.getLrList({}).then((res: any) => {
      this.lrList = res.data;
      this.auto_number = res.auto_design;
    });
  }
  agentlist() {
    this.poservice.agentlist({}).then((res: any) => {
      this.agentList = res.data;
    });
  }
  typelist() {
    this.poservice.typelist({}).then((res: any) => {
      this.typeList = res.data;
    });
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.codeList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_name: id });
      this.designdata.party_id = fitem["party_id"];
      return fitem["party_name"];
    }
    return "";
  }
  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id + "" });
      if (!fitem) {
      }

      return fitem["finyear"];
    }
    return "";
  }

  onSaveGrn(): void {
    let invNoExists = true;
    if (this.grnData.gr_type == "COURIER") {
      invNoExists = true;
    } else if (this.grnData.gr_type == "TRANSPORT") {
      if (this.grnData.inv_no == "") {
        invNoExists = false;
      }
    }
    if (
      this.grnData.po_no == "" ||
      this.grnData.grn_type == "" ||
      !invNoExists
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      if (this.grnData.inv_amnt !== parseInt(this.grnData.grandTotal)) {
        swal({
          title: "Invoice Amount and Grand Total are not equal",
          //  timer: 1000,
          type: "warning",
          showCancelButton: false,
          showConfirmButton: false,
        });
      }

      this.data.grnList.forEach((el) => {
        let data = this.grnCompareList.find(
          (temp) => temp.pd_code == el.pd_code && temp.shade == el.color
        );
        if (!data) {
          data = {
            pd_code: el.pd_code,
            color: el.shade,
            shade: el.color,
            width: el.recvd_width,
            quality: el.quality,
            type: el.type,
            rate: el.rate,
            lc_per: el.lc_per,
            amount: el.amount,
            style: el.style,
            design_no: el.design_no,
            qty: 0,
          };
          this.grnCompareList.push(data);
        }
        data.qty += el.qty;
      });
      let tempArry = [];
      this.invoiceList.forEach((element) => {
        let data = this.grnCompareList.filter(function (temp) {
          if (
            temp.pd_code == element.design_no &&
            temp.shade == element.shade &&
            temp.qty !== element.qty
          ) {
            let diff = element.qty - temp.qty;
            if (diff < 0) {
              temp["type"] = "EXCESS";
            } else {
              temp["type"] = "SHORTAGE";
            }
            temp["difference"] = diff;
            tempArry.push(temp);
          }
        });
      });
      this.mismatchList = tempArry;
      this.data.mismatchList = this.mismatchList;
      let params: any = Object.assign({}, this.grnData);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.data);
      params["pvt_mark"] = this.grnData.pvt_mark || "";
      params["lr_id"] = this.grnData.lr_id || "";
      params["lr_amnt"] = this.grnData.lr_amnt || "";
      params["lr_date"] = this.grnData.lr_date || "";
      params["grn_date"] = this.datePipe.transform(
        params["grn_date"],
        "yyyy-MM-dd"
      );
      params["narration"] = this.grnData.narration;
      let that = this;

      swal({
        title: "Are you sure to save this Grn?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.grn
          .saveGrn(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
                // that.saveEvent.emit();
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            if (res.description.includes("Undefined variable")) {
              if (res.description.split(": ")[1] == "lr_date") {
                res.message = "Lr Date is Undefined";
              } else if (res.description.split(": ")[1] == "diff_days") {
                res.message = "Difference days is Undefined";
              } else {
                res.message = res.description.split(": ")[1] + " is Undefined";
              }
            }
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  loadeditgrnlist() {
    let params = {
      grn_id: this.grnData.grn_id,
      grn_qty : true
    };
    this.grn.getEditGrnList(params).then((res: any) => {
      this.data.grnList = res.data;
      this.design_no = res.design_no - 1;
      this.calcTotal();
      // this.change.detectChanges();
      // this.calcQty();
    });
  }
  // totalamount() {
  //     let params = {
  //         grn_id: this.grnData.grn_id,
  //     };
  //     this.grn
  //         .totalamount(params)
  //         .then((res: any) => {

  //             this.data.grnList = res.data;
  //             this.design_no = res.design_no - 1;
  //             this.calcTotal();
  //             // this.calcQty();

  //         });
  // }

  onClickCode(party_code) {
    let partyCodeList = _.filter(this.codeList, { code: party_code });
    this.partyCodeList = partyCodeList;
    let poNoList = _.filter(this.poList, { party_code: party_code });
    this.poNoList = poNoList;
  }
  onClickParty(party_name) {
    let LRList = _.filter(this.lrList, { party_name: party_name });
    this.LRList = LRList;
  }
  onClickLr(lr_no) {
    if (lr_no !== "") {
      if (this.grnData.invoice_type == "TRANSPORT") {
        let invList = _.filter(this.lrList, { lr_no: lr_no });
        this.invList = invList;

        this.grnData["lr_date"] = invList[0]["lr_date"];
        this.grnData.lr_y_date = invList[0]["lr_date"];
        this.grnData["lr_amnt"] = invList[0]["lr_amount"];
        this.grnData["lr_id"] = invList[0]["plr_id"];
        this.grnData.pvt_mark = invList[0]["pvt_mark"];
      } else if (this.grnData.invoice_type == "COURIER") {
        let invList = _.filter(this.lrList, { courier_no: lr_no });
        this.invList = invList;

        if (invList.length > 1) {
          this.grnData["lr_date"] = this.tempData["courier_date"];
          this.grnData["lr_y_date"] = this.tempData["courier_date"];
        } else {
          this.grnData["lr_date"] = invList[0]["courier_date"];
          this.grnData["lr_y_date"] = invList[0]["courier_date"];
        }
      }
      let params = {
        lr_no: lr_no,
        po_id: this.grnData.po_id,
      };
      this.grn.getDesignList(params).then((res: any) => {
        this.invoiceList = res.data;
      });

      this.calcDiff();
      this.calcLCrate();
    } else {
      this.grnData.lr_y_date = "";
      this.grnData["lr_amnt"] = "";
    }
  }
  colorVal(data, ind) {
    if(data != ''){
      if (this.colorList.find((name) => name.name == data)) {
        return true;
      } else {
        swal("Please Check The Color Spelling!");
        this.data.grnList[ind].shade = "";
        return false;
      }
    }
  }

  calcLCrate() {
    for (let i = 0; i < this.data.grnList.length; i++) {
      let cooly = this.grnData["no_of_bundle"] * 30;
      // let bundlepercooly = this.grnData['cooly_amt'] / cooly;
      if (isNaN(cooly)) {
        cooly = 0;
      }
      let totalrate = 0;
      totalrate = this.grnData.taxinvamount + this.grnData.lr_amount + cooly;
      this.data.grnList[i].lc_per =
        (totalrate / this.grnData.totalinvamt) * 100;
      this.data.grnList[i].lc_per = Math.round(
        this.data.grnList[i].lc_per
      ).toFixed(2);

      this.grnData["lc_per"] = this.data.grnList[i].lc_per;
    }

    return this.data.grnList;
  }

  onEnterInvRefNo() {
    let params = {
      inv_ref_no: this.grnData.inv_ref_no,
    };

    this.grn.getInvRefDetails(params).then((res: any) => {
      this.tempData = res.data;
      if (
        (res.data.lr_stage == "LR Open" ||
          res.data.lr_stage == "LR Delivery") &&
        res.data.invoice_type != "COURIER"
      ) {
        swal("LR NOT CLOSED..PLEASE ENTER `LR UPDATE` TO CLOSE LR");
        return;
      }
      this.grnData.party_code = res.data.party_code;
      this.grnData.party_name = res.data.party_name;
      this.grnData.party_id = res.data.party_id;
      this.grnData.po_no = res.data.po_no;
      this.grnData.po_id = res.data.po_id;
      this.grnData.invoice_no = res.data.invoice_no;
      this.grnData.lr_no = res.data.lr_no;
      this.grnData.inv_no = res.data.invoice_no;
      this.getDesign(res.data.po_no);
      this.onEnterpono(res.data.po_no);

      let invDate = [];
      invDate[0] = res.data;

      this.grnData["inv_date"] = invDate[0]["invoice_date"];
      this.grnData["inv_y_date"] = invDate[0]["invoice_date"];
      this.grnData["inv_amnt"] = invDate[0]["grand_total"];
      this.grnData["inv_id"] = invDate[0]["inv_id"];
      this.grnData["freight_charges"] = invDate[0]["freight_charge"];
      this.grnData["no_of_bundle"] = invDate[0]["no_of_bales"];
      this.grnData["cooly_amt"] = invDate[0]["cooly_amt"];
      this.grnData["othersamt"] = invDate[0]["others"];
      this.grnData["taxinvamount"] = invDate[0]["tax_amount"];
      this.grnData["totalinvamt"] = invDate[0]["totalamt"];
      this.grnData["invoice_type"] = invDate[0]["invoice_type"];
      this.grnData["lr_amount"] = invDate[0]["lr_amount"];
      this.grnData["indent_no"] = invDate[0]["indent_no"];

      this.onClickLr(res.data.lr_no);
    });
  }

  onClickInv(invoice_no) {
    if (invoice_no != "") {
      let grpo = this.grnData.po_id;
      var grpo1 = new RegExp(grpo, "g");
      // let invDate = _.filter(this.lrList, { invoice_no: invoice_no });
      let invDate = [];
      this.lrList.forEach((element) => {
        let elpo = element.po_id;
        let elpo1 = elpo.toString();

        if (element.invoice_no == invoice_no) {
          invDate[0] = element;
        }
      });

      this.grnData["inv_date"] = invDate[0]["invoice_date"];
      this.grnData["inv_y_date"] = invDate[0]["invoice_date"];
      this.grnData["inv_amnt"] = invDate[0]["grand_total"];
      this.grnData["inv_id"] = invDate[0]["inv_id"];
      this.grnData["freight_charges"] = invDate[0]["freight_charge"];
      this.grnData["no_of_bundle"] = invDate[0]["no_of_bales"];
      this.grnData["cooly_amt"] = invDate[0]["cooly_amt"];
      this.grnData["othersamt"] = invDate[0]["others"];
      this.grnData["taxinvamount"] = invDate[0]["tax_amount"];
      this.grnData["totalinvamt"] = invDate[0]["totalamt"];
      this.grnData["invoice_type"] = invDate[0]["invoice_type"];
      this.grnData["lr_amount"] = invDate[0]["lr_amount"];
      //  this.grnData['inv_amnt'] = invDate[0]['inv_amnt'];
    } else {
      this.grnData["inv_y_date"] = "";
      this.grnData["inv_amnt"] = "";
    }
  }

  onClickPartyDesign(party_design, party_shade, ind, canShowSwal) {
    this.sample_check = false;
    this.calcLCrate();
    this.data.grnList[ind].p_shade = party_shade;
    this.data.grnList[ind].des_no = party_design;

    let params = {
      party_design: party_design,
      shade: party_shade,
      party_id: this.grnData.party_id,
      po_id: this.grnData.po_id
    };

    let that = this;
    that.grn.getsampleColor(params).then((res: any) => {
      if (res.data.length > 0) {
        that.tempcolorList = res.data;
        that.sample_check = true;
        // console.log(that.tempcolorList);
      }
    });
    that.grn.getPartyDesignDetails(params).then((res: any) => {

      if (res.success == true) {
  
        if (res.design_type == "PLAIN") {
          that.data.grnList[ind].design_type = res.data["design_type"];
          that.data.grnList[ind].rate = res.data["party_rate"];
          that.data.grnList[ind].design_no = res.data["core_designno"];
          // that.data.grnList[ind].shade = res.data["fabric_color"];
          that.data.grnList[ind].style = res.data["shirt_style"];
          that.data.grnList[ind].recvd_width = res.data["width"];
          that.data.grnList[ind].quality = res.data["quality"];
          that.data.grnList[ind].type = res.data["fabric_type"];
          that.data.grnList[ind].po_id = res.po_id;
          that.data.grnList[ind].shirt_style = res.data["shirt_style"];

          if (canShowSwal == "color") {
            swal(
              "THIS IS A  " + that.data.grnList[ind].design_type + " DESIGN"
            );
          }
        } else {
          let newExists = res.data;

          that.data.grnList[ind].design_type = "NEW";
          that.data.grnList[ind].design_no = res.data["fabric_design"];
          that.data.grnList[ind].rate = res.data["rate"];
          that.data.grnList[ind].style = res.data["shirt_style"];
          that.data.grnList[ind].recvd_width = res.data["width"];
          that.data.grnList[ind].quality = res.data["quality"];
          that.data.grnList[ind].type = res.data["type"];
          // that.data.grnList[ind].shade = res.data["fabric_color"];
          that.data.grnList[ind].po_id = res.po_id;
          that.data.grnList[ind].shirt_style = res.data["shirt_style"];
          
          if (canShowSwal == "color") {
            swal({
              title:
                "LAST GENERATED DETAILS " +
                party_design +
                " - " +
                res.design_no,
              html:
                "PARTY CODE : " +
                newExists.party_code +
                "<br/>" +
                "PO NO : " +
                newExists.po_no +
                "<br/>" +
                " PO DATE : " +
                newExists.po_date +
                "<br/>",
            });
          }
        }

        that.grnData.invoice_no = 0;
        that.grnData.lr_no = 0;
        that.grnData.inv_no = 0;
        that.grnData.po_no = that.grnData.samp_po_no;
      } else if (that.data.grnList[ind].design_from == "ORDERED") {
        let exists = this.designList.filter(
          (el) => el.design_no == party_design
        );
        if (!exists && exists.length == 0) {
          this.data.grnList[ind].pd_code = "";
          $("#pd_code-" + ind).focus();
          swal("Design no doesn't exists in Invoice");
        } else {
          if (
            exists[0].design_type == "PLAIN"
          ) {
            if (canShowSwal == "color") {
              that.data.grnList[ind].design_type = "";
              that.data.grnList[ind].design_no = "";
              that.data.grnList[ind].rate = "";
              that.data.grnList[ind].style = "";
              that.data.grnList[ind].recvd_width = "";
              that.data.grnList[ind].quality = "";
              that.data.grnList[ind].shade = "";
              that.data.grnList[ind].type = "";
              setTimeout(() => {
                $("#shade-" + ind).focus();
              }, 500);
              swal("Shade doesn't exists in purchase order");
              return;
            }
          }
          
        }
        
      }else if(that.data.grnList[ind].design_from == "NON-ORDERED"){
        that.data.grnList[ind].design_type = "NEW";
      }
      if (res.color) {
        if(res.color.length > 0){
          that.colorList = res.color;
        }
      } else {
        that.colorList = that.colorListback;
      }
    });
  }

  // onclickpdcode(designshade, shade, ind, canShowSwal) {
  //   this.calcLCrate();
  //   this.data.grnList[ind].des_no = designshade;
  //   this.data.grnList[ind].p_shade = shade;

  //   let params = {
  //     pdesign_no: this.data.grnList[ind].des_no,
  //     shade: this.data.grnList[ind].p_shade,
  //     party_id: this.grnData.party_id,
  //   };
  //   this.grn.getCoreList(params).then((res: any) => {
  //     if (res.success == true) {
  //       this.data.grnList[ind].design_type = res.data[0]["type"];
  //       this.data.grnList[ind].design_no = res.data[0]["core_designno"];
  //       this.data.grnList[ind].shade = res.data[0]["fabric_color"];
  //       // this.data.grnList[ind].color = res.data[0]['shade'];
  //       this.data.grnList[ind].style = res.data[0]["fabric_style"];
  //       this.data.grnList[ind].isNew = false;
  //       if (canShowSwal == "color") {
  //         swal("THIS IS A  " + this.data.grnList[ind].design_type + " DESIGN");
  //       }
  //     } else {
  //       this.data.grnList[ind].design_type = "NEW";
  //       this.onClickDesign(this.data.grnList[ind].des_no, ind);
  //     }
  //     if (res.color.length > 0) {
  //       this.colorList = res.color;
  //     } else {
  //       this.colorList = this.colorListback;
  //     }
  //   });
  // }
  // onClickDesign(designno, ind) {
  //   //  let designData =  _.filter(this.designList, { design_no: designno });

  //   //   this.data.grnList[ind].des_no = designData[0]['design_no'];
  //   //      this.data.grnList[ind].design_shade = designData[0]['design_shade'];
  //   let des_no = this.data.grnList[ind].des_no;
  //   let design_shade = this.data.grnList[ind].color;
  //   for (let i = 0; i < this.data.grnList.length; i++) {
  //     if (i != ind && designno == this.data.grnList[i].des_no) {
  //       let design_no = this.data.grnList[i].design_no;
  //       this.data.grnList[ind].design_no = design_no;
  //       if (this.data.grnList[i].isNew == true) {
  //         this.data.grnList[ind].isNew = false;
  //       }

  //       return;
  //     }
  //   }
  //   this.generateOdNo(des_no, ind, design_shade);
  // }
  // generateOdNo(des_no, ind, design_shade) {
  //   let params = {
  //     design_shade: design_shade,
  //     des_no: des_no,
  //     party_id: this.grnData.party_id,
  //   };
  //   let that = this;
  //   that.grn.getAutoDesignNo(params).then((res: any) => {
  //     //  this.data.grnList[ind].design_no = res;
  //     that.data.grnList[ind].design_no = that.isSameDesignNo(
  //       des_no,
  //       res.design_no,
  //       ind,
  //       design_shade,
  //       res.newExists,
  //       res.coreExists,
  //       res.type
  //     );
  //   });
  // }
  // isSameDesignNo(party_des_no, res, ind, pd_code, newExists, coreExists, type) {
  //   //
  //   for (let i = 0; i < this.data.grnList.length - 1; i++) {
  //     if (
  //       ind != i &&
  //       res == this.data.grnList[i].design_no &&
  //       pd_code != this.data.grnList[i].des_no
  //     ) {
  //       res = res + 1;
  //       this.isSameDesignNo(
  //         party_des_no,
  //         res,
  //         ind,
  //         pd_code,
  //         newExists,
  //         coreExists,
  //         type
  //       );
  //     }
  //   }
  //   if (Object.entries(newExists).length > 0 && pd_code != "") {
  //     swal({
  //       title: "LAST GENERATED DETAILS " + party_des_no + " - " + res,
  //       html:
  //         "GRN NO : " +
  //         newExists.grn_no +
  //         "<br/>" +
  //         " GRN DATE : " +
  //         newExists.grn_date +
  //         "<br/>" +
  //         " INVOICE NO : " +
  //         newExists.invoice_no +
  //         "<br/>" +
  //         " INVOICE DATE : " +
  //         newExists.invoice_date,
  //     });
  //     this.data.grnList[ind].isNew = false;
  //   } else {
  //     this.data.grnList[ind].isNew = true;
  //   }
  //   return res;
  // }
  OnselectShade(color, ind) {
    let shade_check = false;
    if (this.tempcolorList.length > 0) {
      let exist = this.tempcolorList.find(el => el.name == color);
  
      if (!exist) {
        shade_check = true;
      }
      // console.log("Check Exist",exist,color,this.tempcolorList)
    };

    if (shade_check) {
      swal("Error", "<h2>Color Not Matched</h2>", "error");
      this.data.grnList[ind].shade = "";
      $("#shade-" + ind).focus();
    }
    else {
      $("#qty-" + ind).focus();
      this.designnoShadeExistsInPO(this.data.grnList[ind].pd_code, this.data.grnList[ind].color, this.data.grnList[ind].design_type,ind)
     
    }
    // console.log(this.data.grnList, "Check nIt Works")

  }
  getSampPoDesign(po_no) {
    var regex = /^[A-Za-z0-9 ]+$/;
    var isValid = regex.test(po_no);
    if (isValid) {
      let params = {
        po_no: po_no,
        grn_type : 'SAMPLE GRN'
      };
      this.grn.getDesign(params).then((res: any) => {
        this.designList = res.data;
        this.grnData.party_code = res.data[0].party_code;
        this.grnData.party_name = res.data[0].party_name;
        this.grnData.party_id = res.data[0].party_id;
        this.grnData.po_id = res.data[0].po_id;
      });
    } else {
      let ponos = po_no.split(",");
      let ind = ponos.length;
      for (let i = 0; i < ponos.length; i++) {
        let params = {
          po_no: ponos[i],
          grn_type : 'SAMPLE GRN'
        };
        this.grn.getDesign(params).then((res: any) => {
          this.designList = this.designList.concat(res.data);
          this.grnData.party_code = res.data[0].party_code;
          this.grnData.party_name = res.data[0].party_name;
          this.grnData.party_id = res.data[0].party_id;
          this.grnData.po_id = res.data[0].po_id;

        });
      }
    }
  }
  getDesign(po_no) {
    var regex = /^[A-Za-z0-9 ]+$/;
    var isValid = regex.test(po_no);
    if (isValid) {
      let params = {
        po_no: po_no,
        grn_type : 'SAMPLE GRN'
      };
      this.grn.getDesign(params).then((res: any) => {
        this.designList = res.data;
        if (this.mode == "Edit") {
          this.partyCtrl.setValue(this.designdata["party_name"]);
        }
      });
    } else {
      let ponos = po_no.split(",");
      let ind = ponos.length;
      for (let i = 0; i < ponos.length; i++) {
        let params = {
          po_no: ponos[i],
          grn_type : 'SAMPLE GRN'
        };
        this.grn.getDesign(params).then((res: any) => {
          this.designList = this.designList.concat(res.data);
          if (this.mode == "Edit") {
            this.partyCtrl.setValue(this.designdata["party_name"]);
          }
        });
      }
    }
  }
  onEnterpono(pono) {
    if (pono != "") {
      var regex = /^[A-Za-z0-9 ]+$/;
      var isValid = regex.test(pono);
      if (isValid) {
        let params = {
          po_no: pono,
        };
        let that = this;
        this.grn.getDesignno(params).then((res: any) => {
          if (res.data.length > 0) {
            that.designnoList = res.data;
            that.grnData["po_id"] = res.data[0].po_id;
            that.grnData["po_date"] = res.data[0]["po_date"];
            // that.grnData.party_code = res.data[0].party_code;
            // that.grnData.party_name = res.data[0].party_name;
            // that.grnData.party_id = res.data[0].party_id;
            // that.calcDiff();
            //that.grnData['diff_days'] = ((parseInt(that.grnData['grn_date']) - that.grnData['po_date']) / (1000 * 60 * 60 * 24));
            //  that.OnclickPartyCode(that.grnData.party_code);
          } else {
            (this.grnData.party_code = ""),
              (this.grnData["po_id"] = ""),
              (this.grnData.party_name = ""),
              (this.grnData["po_date"] = ""),
              (this.grnData["diff_days"] = "");
            this.toasterService.pop({
              bodyOutputType: 1,
              type: "error",
              title: "Please Enter the valid Po.no",
            });
          }
        });
      } else {
        let ponos = pono.split(",");
        let ind = ponos.length;
        let params = {
          po_no: ponos[ind - 1],
        };
        let that = this;
        this.grn.getDesignno(params).then((res: any) => {
          if (res.data.length > 0) {
            that.designnoList = that.designnoList.concat(res.data);
          }
        });
      }
    } else {
      (this.grnData.party_code = ""),
        (this.grnData["po_id"] = ""),
        (this.grnData.party_name = ""),
        (this.grnData["po_date"] = ""),
        (this.grnData["diff_days"] = "");
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "Please Enter the valid Po.no",
      });
    }
  }
  poMerge(pono) {
    let ponos = pono.split(",");
    let ind = ponos.length;
    let params = {
      po_no: ponos[ind - 1],
    };
    let that = this;
    this.grn.getDesignno(params).then((res: any) => {
      if (res.data.length > 0) {
        that.designnoList = that.designnoList.concat(res.data);
        this.grnData["po_id"] = this.grnData.po_id + "," + res.data[0].po_id;
      }
    });
  }
  calcDiff() {
    let date1 = new Date(this.grnData["lr_y_date"]);
    let date2 = new Date(this.grnData.grn_date);
    let diffDays = 0;
    this.grnData["diff_days"] = (date2.getTime() - date1.getTime()) / 86400000;
  }
  OnclickPartyCode(code) {
    let params = {
      code: code,
    };

    let that = this;
    this.grn.partyList(params).then((res: any) => {
      that.partyList = res.data;
      // that.grnData['party_name'] = res.data[0].party_name;
      // that.grnData['party_id'] = res.data[0].party_id;
    });
  }
  onchangeodno(od_no, ind) {
    let pdesign = this.data.grnList[ind].des_no;

    for (let i = 0; i < this.data.grnList.length; i++) {
      if (pdesign == this.data.grnList[i].des_no) {
        this.data.grnList[i].design_no = od_no;
      }
    }
  }
  generateDesignNo(ind) {
    if (this.data.grnList[ind].design_no == "") {
      this.data.grnList[ind].design_no = this.design_auto_no + ind;
    }
  }
  generateEditDesignNo(ind, fld) {
    let design_shade = this.data.grnList[ind].design_shade;
    if (fld == "designno") {
      if (this.mode == "Edit" && this.data.grnList[ind].design_no == "") {
        this.design_no += 1;
        this.data.grnList[ind].design_no = this.design_no;
      } else {
        this.generateDesignNo(ind);
      }
    }
  }
  calctot(ind) {
    let grn = this.data.grnList[ind];
    let rate = grn.rate;
    let lc_per = grn.lc_per;
    let qty = grn.qty;
    let amount = rate * qty;
    grn.lc_rate = (rate * lc_per) / 100;
    grn.amount = parseFloat(amount.toFixed(3));
    this.calcTotal();
    // this.calcRnd();
  }

  oncheckemptyrow() {
    let gnr = this.data.grnList;
    let grnList = [];
    for (let i = 0; i < gnr.length; i++) {
      if (gnr[i].pd_code != "") {
        grnList.push(gnr[i]);
      }
    }
    this.data.grnList = grnList;
    if (this.mode == "Add") {
      this.getAuto();
    }
    if (this.mode == "Edit") {
      this.onSaveGrn();
    }
  }

  calcTotal() {
    let grn = this.data.grnList;
    let totqty = 0,
      totalamt = 0;
    let disamt = 0;
    let roundoff = 0;
    let grantTotal = 0;
    let rnd = 0;
    let tax_per = this.grnData.tax_per;
    let taxamt = 0;
    let discount = this.grnData.discount;
    let tax = this.grnData.tax_per;
    let extras = this.grnData.extras;
    let otheramt = this.grnData.others;

    for (let i = 0; i < grn.length; i++) {
      let grndata = grn[i];
      totqty += parseFloat(grndata.qty);
      totalamt += grndata.amount;
    }
    taxamt = ((totalamt - discount + extras) * tax_per) / 100;
    if (isNaN(taxamt)) {
      taxamt = 0;
    }
    if (isNaN(discount)) {
      discount = 0;
    }
    if (isNaN(extras)) {
      extras = 0;
    }
    if (isNaN(otheramt)) {
      otheramt = 0;
    }

    grantTotal =
      Number(totalamt) -
      Number(discount) +
      Number(taxamt) +
      Number(extras) +
      Number(otheramt);

    this.grnData.totalqty = parseFloat(totqty.toFixed(2));
    this.grnData.tax_amount = parseFloat(taxamt.toFixed(2));
    this.grnData.totalamt = parseFloat(totalamt.toFixed(2));
    this.grnData.grand_total = grantTotal + this.grnData.round_off;
    this.grnData.grand_total = parseFloat(this.grnData.grand_total.toFixed(2));
    this.grnData.grandTotal = parseFloat(this.grnData.grand_total.toFixed(2));
    this.grnData.grand_total = this.moneyFormat(this.grnData.grand_total);
  }

  moneyFormat(nStr) {
    if (nStr == null || nStr == undefined || nStr == "" || nStr == 0)
      return 0.0;
    let no = parseInt(nStr).toFixed(2);
    /*if (no < 0) {
            nStr = no * -1;
        }
        nStr += '';*/

    let x = no.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    let z = 0;
    let len = x1.length;
    let num = len / 2 - 1;
    let newval = Math.floor(num);

    while (rgx.test(x1)) {
      if (z > 0) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      } else {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
        rgx = /(\d+)(\d{2})/;
      }
      z++;
      newval--;
      if (newval == 0) {
        break;
      }
    }

    let out = x1 + x2;
    // if (Number(no) < 0) {
    //     out = "(" + out + ")";
    // }
    return out;
  }
  showHeader() {
    this.bodyShow = false;
    this.footerShow = false;
    this.headerShow = true;
  }
  showbody() {
    this.bodyShow = true;
    this.footerShow = true;
    this.headerShow = false;
    let focusOn: string;
    if (this.grnData.gr_type == "COURIER") {
      focusOn = "design_from";
    } else {
      focusOn = "pdcode";
    }
    setTimeout(() => {
      $("#" + focusOn + "-0").focus();
    }, 500);
  }

  CheckNondes(ind) {
//  console.log('IHIHIBYBYBYBIYBYIBYIBY')
    if(this.mode == "Edit"){
      if(this.data.grnList[ind].design_from == "NON-ORDERED"){
      this.data.grnList[ind].pd_code = "";
  
      this.data.grnList[ind].amount = 0;
      this.data.grnList[ind].design_no = "";
      }

    }

  }

  designnoExistsInPO(design_no, color, ind) {

    if (design_no != "" && this.data.grnList[ind].design_from == "ORDERED") {
      let exists = this.designList.find((el) => el.design_no == design_no);

      if (!exists) {
        this.data.grnList[ind].pd_code =  '';
        swal("Non-ordered design...Please enter ordered design");
        return;
      }else{
        let colorList = this.designList.map((el) => {
          if(el.design_no == design_no){
            return el.shade;
          }
        });
        if(colorList.length > 0){

          let shadeArr = '';
          colorList.forEach((el) => {
            if(el){
              shadeArr += el + ",";
            }
          });
          
          this.designColorList = shadeArr.slice(0,-1).split(",").filter(function (color, index, self) { 
            return self.indexOf(color) === index;
          });
        }

        this.onClickPartyDesign(design_no,color,ind, 'design');
      }
    }
  }
  designnoShadeExistsInPO(design_no, shade, design_type, ind) {

    // console.log("ITsSSSSSSSSSSSSSSS Called Or NNNNNNOt")
    let canProceed = false;

    if(design_type == 'CORE' || design_type == 'GANG'){
      if(shade != ''){
      
        if (this.data.grnList[ind].design_from == "NON-ORDERED") {
          canProceed = true;
          return canProceed;
        }
    
        let designExists = this.designList.filter(
          (el) => el.design_no == design_no
        );
        if (designExists && designExists.length > 0) {
          let shadeExists: any;
    
          for (let el of designExists) {
            shadeExists = String(el.shade)
              .split(",")
              .find((ex) => ex == shade);
            if (shadeExists) {
              canProceed = true;
              break;
            }
          }
          if (!shadeExists) {
            this.data.grnList[ind].color =  '';
            canProceed = false;
            swal("Non-ordered shade for this design");
          }
        }
      }
    }else{
      canProceed = true;
    }
  
   
  if(canProceed){
    this.onClickPartyDesign(design_no,shade,ind, 'color');
  }else{
    this.data.grnList[ind].color =  '';
    swal("Non-ordered shade for this design");
  }
    return canProceed;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/grn/addEditSampleSwatchGrn.ts